export default __webpack_public_path__ + "static/media/image_placeholder.a59d3b8e.jpg";